module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.data.td.length > 0 && Array.isArray(_vm.data.td)) ? _c('table', {
    staticClass: "table table-bordered",
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('thead', [_c('tr', _vm._l((_vm.data.td[0]), function(value, keyName) {
    return _c('th', {
      key: keyName + value,
      staticClass: "vgt-left-align",
      staticStyle: {
        "min-width": "auto",
        "width": "auto"
      }
    }, [_c('span', [_vm._v(_vm._s(keyName) + "+1")])])
  }), 0)]), _vm._v(" "), _c('tbody', _vm._l((_vm.data.td), function(row) {
    return _c('tr', _vm._l((row), function(record) {
      return _c('td', {
        staticClass: "vgt-left-align"
      }, [_c('span', [_vm._v(_vm._s(_vm.renderRecord(record)))])])
    }), 0)
  }), 0)]) : _c('div', [_vm._v("\n  Preview not available.\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-961e7e2a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/reusables/StandardTable.vue
// module id = 1725
// module chunks = 1